import { render } from "./NavMenuNode.vue?vue&type=template&id=fd37de2a&scoped=true&lang=html"
import script from "./NavMenuNode.vue?vue&type=script&lang=js"
export * from "./NavMenuNode.vue?vue&type=script&lang=js"

import "./NavMenuNode.vue?vue&type=style&index=0&id=fd37de2a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fd37de2a"

export default script